import { Box } from "@itandi/itandi-bb-ui/Box";
import { useRouter } from "next/router";
import { StatusHandleVendorButtons } from "~/components/common/statuses/StatusHandleVendorButtons";
import { useDeals } from "~/hooks/vendors/useDeals";
import { useSessions } from "~/hooks/vendors/useSessions";
import { isOriginVendor } from "~/models/DealVendorCompany";
import { FINISHED, IN_CONSTRUCTION } from "~/models/Status";
import Styles from "./statuses.module.scss";

export function AwaitingAcceptance() {
	const router = useRouter();
	const { id: dealId = null } = router.query;
	const { data: deal } = useDeals().show(
		dealId === null ? null : Number(dealId)
	);
	const { data: session } = useSessions().index();
	if (deal === null || session === null) {
		return null;
	}
	return (
		<div>
			<h3 className={Styles.Title}>完了報告を送信しました</h3>
			<Box marginY={16}>
				<p>検収完了をお待ち下さい。</p>
			</Box>
			{isOriginVendor(deal, session.vendorCompany.id) && (
				<StatusHandleVendorButtons
					forwardDisabled
					nextStatusId={FINISHED}
					prevStatusId={IN_CONSTRUCTION}
				/>
			)}
		</div>
	);
}
